import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import Eyebrow from '@/components/landing/eyebrow'

interface SectionHeadingProps {
    id: string
    eyebrow: string
    title: string
    intro?: string
    centered?: boolean
    className?: string
}

const SectionHeading: FC<SectionHeadingProps> = ({ id, eyebrow, title, intro, centered = false, className }): ReactNode => {
    return (
        <div className={cn('max-w-3xl', centered && 'mx-auto text-center', className)}>
            <Eyebrow centered={centered}>
                {eyebrow}
            </Eyebrow>

            <h2
                id={id}
                className='display-heading mt-5 font-heading text-4xl font-semibold uppercase leading-[0.95] tracking-tight text-balance text-foreground sm:text-5xl lg:text-6xl'
            >
                {title}
            </h2>

            {intro && (
                <p className={cn('mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground text-pretty sm:text-lg', centered && 'mx-auto')}>
                    {intro}
                </p>
            )}
        </div>
    )
}

export default SectionHeading
